import * as React from 'react'
import { Badge, BadgeItem } from './Badge'

export interface BadgesProps {
  items: BadgeItem[]
  header?: string
}

const styles = require('./styles')

export const BadgeList = ({ header, items }: BadgesProps) => {
  const badges: JSX.Element[] = []

  if (header) {
    badges.push(<span>{header}</span>)
  }
  items.forEach((item, index) => badges.push(<Badge key={index} badgeItem={item} />))
  return <div className={styles.badgeListcontainer}>{badges}</div>
}
